import React from "react";
import "./DataTagSensitivityFilter.scss";

const OPTIONS = [
  { key: "HIGH", color: "#E51959" },
  { key: "MEDIUM", color: "#FC6213" },
  { key: "LOW", color: "#081981" },
  { key: "NO_SENSITIVITY", color: "#650176" },
];

export default function DataTagSensitivityFilter({
  value = [],
  onChange,
}) {
  const toggleSelection = (key) => {
    const updated = value.includes(key)
      ? value.filter((x) => x !== key)
      : [...value, key];

    onChange?.(updated);
  };

  return (
    <div className="sensitivity-filter-container">
      {OPTIONS.map((opt) => {
        const isActive = value.includes(opt.key);

        return (
          <div
            key={opt.key}
            className={`sensitivity-dot ${isActive ? "active" : ""}`}
            style={{
              borderColor: opt.color,
              backgroundColor: isActive ? opt.color : "transparent",
            }}
            title={opt.key}
            onClick={() => toggleSelection(opt.key)}
          />
        );
      })}
    </div>
  );
}
